// extracted by mini-css-extract-plugin
module.exports = {"options":"PauseMenu_options__28bnz","option":"PauseMenu_option__cO12r","icon":"PauseMenu_icon__1xBPD","optionTitle":"PauseMenu_optionTitle__26H4R"};